import type { DroitImage, EtatSupportImage } from '../types';

/** L'etat en saisie : '' = non renseigne. */
export type SaisieEtatSupport = '' | EtatSupportImage;

/** La saisie du droit a l'image dans le formulaire d'adherent — un seul etat depuis la 0.67.0. */
export interface SaisieDroitImage {
  etat: SaisieEtatSupport;
  dateSignature: string;
  commentaire: string;
}

/** La saisie initiale, depuis la fiche — jamais depuis un chargement propre au formulaire. */
export function saisieDepuisDroitImage(droit: DroitImage | null | undefined): SaisieDroitImage {
  return {
    etat: droit?.etat ?? '',
    dateSignature: droit?.date_signature ?? '',
    commentaire: droit?.commentaire ?? '',
  };
}

function etatDe(source: DroitImage | SaisieDroitImage | null | undefined): SaisieEtatSupport {
  if (!source) return '';
  return 'dateSignature' in source ? source.etat : (source.etat ?? '');
}

/** Pour une pastille : accorde, refuse, ou non renseigne. */
export function bilanDroitImage(
  source: DroitImage | SaisieDroitImage | null | undefined,
): 'non_renseigne' | 'accorde' | 'refuse' {
  const etat = etatDe(source);
  return etat === '' ? 'non_renseigne' : etat;
}

/** « accordé », « refusé » ou « non renseigné ». */
export function resumerDroitImage(
  source: DroitImage | SaisieDroitImage | null | undefined,
): string {
  const etat = etatDe(source);
  return etat === 'accorde' ? 'accordé' : etat === 'refuse' ? 'refusé' : 'non renseigné';
}
